<template>
  <div class="house-for-rent">
    <div class="column">
      <b-field
        :label="`${$t('company_type')}`"
        :message="$t(validation.firstError('companyType'))"
      >
        <b-select :placeholder="$t('please_select')" v-model="companyType">
          <option
            v-for="option in companyTypes"
            :value="option.id"
            :key="option.id"
          >
            {{ $t(option.value) }}
          </option>
        </b-select>
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('expect_tax_value')}`"
        :message="$t(validation.firstError('expectTaxValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="expectTaxValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div v-if="isShowResult" class="column">
      <b-table
        :data="this.tableData"
        :columns="this.tableColumns"
        :hoverable="true"
        :bordered="true"
        :striped="true"
      >
      </b-table>
    </div>

    <div v-if="isShowResult" class="column is-full">
      {{ $t("remark") }}
    </div>

    <div v-if="isShowResult && this.companyType <= 3" class="column is-full">
      1. {{ $t("remark_6") }}
    </div>

    <div v-if="isShowResult && this.companyType === 4" class="column is-full">
      1. {{ $t("remark_7")
      }}<strong
        ><u>{{ $t("remark_7_1") }}</u></strong
      >{{ $t("remark_7_2")
      }}<strong
        ><u>{{ $t("remark_7_3") }}</u></strong
      >{{ $t("remark_7_4")
      }}<strong
        ><u>{{ $t("remark_7_5") }}</u></strong
      >{{ $t("remark_7_6") }} <br />
      2. {{ $t("remark_8")
      }}<strong
        ><u>{{ $t("remark_8_1") }}</u></strong
      >{{ $t("remark_8_2") }}
    </div>

    <div v-if="isShowResult" class="column is-full">
      {{ $t("disclaimer1") }} <br />
      {{ $t("disclaimer2") }}
    </div>

    <div class="column">
      <b-button
        @click="calculate"
        class="is-primary"
        style="background-color: rgba(46, 110, 182, 0.9)"
      >
        {{ $t("calculate") }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyType: 1,
      companyTypes: [
        {
          id: 1,
          value: "normal_company",
        },
        {
          id: 2,
          value: "non_resident_company",
        },
        {
          id: 3,
          value: "high_tech_company",
        },
        {
          id: 4,
          value: "low_profit_company",
        },
      ],
      expectTaxValue: "",
      tableData: "",
      tableColumns: "",
      isShowResult: false,
    };
  },

  validators: {
    companyType: function(value) {
      return this.$validator()
        .value(value)
        .required();
    },

    expectTaxValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .integer()
        .custom(() => {
          if (this.companyType === 4) {
            if (value > 3000000) {
              this.isShowResult = false;
              return "simpleVueValidator_over_three_million";
            }
          }
        });
    },
  },

  //   computed: {

  //   },

  methods: {
    calculate() {
      if (this.companyType === 4) {
        this.tableData = [
          {
            expect_tax_value: this.$options.filters.formatNumber(
              this.expectTaxValue
            ),
            over_one_million: this.$options.filters.formatNumber(
              this.calOverOneMillion()
            ),
            between_one_million_and_three_million: this.$options.filters.formatNumber(
              this.calOverOneMillionBetweenThreeMillion()
            ),
            needed_tax: this.$options.filters.formatNumber(this.calNeededTax()),
          },
        ];
      } else {
        this.tableData = [
          {
            expect_tax_value: this.$options.filters.formatNumber(
              this.expectTaxValue
            ),
            tax_rate: this.calTaxRate(),
            company_tax: this.$options.filters.formatNumber(
              this.calNormalTax()
            ),
          },
        ];
      }
      //   let results = [
      //     {
      //   tax_revenue: this.$options.filters.formatNumberWithoutPoint(
      //     this.calTaxRevenue()
      //   ),
      //   tax: this.$options.filters.formatNumberWithoutPoint(this.calTax()),
      //   except_house_tax: this.$options.filters.formatNumberWithoutPoint(
      //     this.calExceptHouseTax()
      //   ),
      //   total_tax_amt: this.$options.filters.formatNumberWithoutPoint(
      //     this.calTotalTax()
      //   ),
      //     },
      //   ];

      //   this.tableData = results;

      this.columns();

      this.$validate().then((success) => {
        if (success) {
          this.isShowResult = true;
        }
      });
    },

    calTaxRate() {
      if (this.companyType === 1) {
        return 0.25;
      } else if (this.companyType === 2) {
        return 0.2;
      } else if (this.companyType === 3) {
        return 0.15;
      }
    },

    calNormalTax() {
      return this.expectTaxValue * this.calTaxRate();
    },

    calOverOneMillion() {
      if (this.expectTaxValue < 1000000) {
        return this.expectTaxValue * 0.25 * 0.2 * 0.5;
      }
      return 1000000 * 0.25 * 0.2 * 0.5;
    },

    calOverOneMillionBetweenThreeMillion() {
      if (this.expectTaxValue <= 1000000) {
        return 0;
      }
      return (this.expectTaxValue - 1000000) * 0.2 * 0.5;
    },

    calNeededTax() {
      return (
        this.calOverOneMillion() + this.calOverOneMillionBetweenThreeMillion()
      );
    },

    columns() {
      if (this.companyType === 4) {
        this.tableColumns = [
          {
            field: "expect_tax_value",
            label: this.$t("expect_tax_value"),
            numeric: true,
          },
          {
            field: "over_one_million",
            label: this.$t("over_one_million"),
            numeric: true,
          },
          {
            field: "between_one_million_and_three_million",
            label: this.$t("between_one_million_and_three_million"),
            numeric: true,
          },
          {
            field: "needed_tax",
            label: this.$t("needed_tax"),
            numeric: true,
          },
        ];
      } else {
        this.tableColumns = [
          {
            field: "expect_tax_value",
            label: this.$t("expect_tax_value"),
            numeric: true,
          },
          {
            field: "tax_rate",
            label: this.$t("tax_rate"),
            numeric: true,
          },
          {
            field: "company_tax",
            label: this.$t("company_tax"),
            numeric: true,
          },
        ];
      }
    },
  },
};
</script>
